// dropdowns and filter field keys
export const POSITION = "position"; // multi-select of rep activity pipeline status
export const ACTIVE_STATUS = "activeStatus"; // multi-select of rep activity pipeline status
export const STATUS = "status"; // multi-select of RepresentativeStatusEnum
export const DISCIPLINE_STATUS = "disciplineStatus"; // multi-select
export const LAST_FOUR_SSN = "lastFourSSN";
export const BIRTH_DATE = "dateOfBirth";
export const PHONE_NUMBER = "phoneNumber";
export const EMAIL_ADDRESS = "email";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const REP_ID = "login";
export const AGENT_ID = "agentId";
export const ONBOARDING_START_DATE = "onboardingStartDate";
export const ONBOARDING_END_DATE = "onboardingEndDate";
export const IS_TEST = "isTest";

export const textPlaceholder = "[ALL]";
